"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateExportJobBody = exports.ExportFilters = exports.ExportOrderBy = exports.AlarmPage = exports.OrderBy = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const Pagination = __importStar(require("../../../../../../../pagination"));
const Device = __importStar(require("../../../../../../device"));
const Tenant = __importStar(require("../../../../../../tenant"));
const Common = __importStar(require("../../common"));
exports.NAMESPACE = 'Culligan.Api.V2.Spec.Legacy.Fleet.Alarms.Schema';
/*
 * `controllers/v2/fleet/alarm.js` + `controllers/v2/fleet/alarm-export.ts`
 */
exports.OrderBy = effect_1.Schema.Literal('severity', 'deviceId', 'time', 'updatedAt', 'name', 'status', 'dismissedAt').annotations({
    identifier: `${exports.NAMESPACE}.OrderBy`,
    title: 'Alarm sort key',
});
/** `PaginatedHistoryAlarms = Pagination.paginate(Culligan.Device.History.Alarm)` */
exports.AlarmPage = Pagination.paginate(Device.History.Alarm).annotations({
    identifier: `${exports.NAMESPACE}.AlarmPage`,
    title: 'Alarm page',
    description: 'One page of the alarm history matching the filters',
});
/** `utils/alarm/domain.ts` `AlarmExportOrderBy`: only the sort keys the Fleet Alarms page exposes. */
exports.ExportOrderBy = effect_1.Schema.Literal('time', 'updatedAt', 'name', 'dismissedAt').annotations({
    identifier: `${exports.NAMESPACE}.ExportOrderBy`,
    title: 'Alarm export sort key',
});
/**
 * `AlarmsExportQueryParams`: the Fleet Alarms page filters captured when the
 * export was requested. Mirrors the list filters minus `customer`, `page`,
 * `size` and `includeActiveOutsideRange`; timestamps are JSON numbers here.
 */
exports.ExportFilters = effect_1.Schema.Struct({
    start: effect_1.Schema.propertySignature(effect_1.Schema.Int.pipe(effect_1.Schema.positive())).annotations({
        description: 'Range start, Unix ms',
    }),
    end: effect_1.Schema.propertySignature(effect_1.Schema.Int.pipe(effect_1.Schema.positive())).annotations({
        description: 'Range end, Unix ms',
    }),
    search: effect_1.Schema.optionalWith(effect_1.Schema.NonEmptyTrimmedString, { exact: true }),
    model: effect_1.Schema.optionalWith(Common.oneOrMany(Device.Class.Common.ModelCode), { exact: true }),
    tenantIds: effect_1.Schema.optionalWith(Common.oneOrMany(Tenant.Id), { exact: true }),
    severity: effect_1.Schema.optionalWith(Device.Capability.Alarm.Severity, { exact: true }),
    status: effect_1.Schema.optionalWith(Device.History.AlarmStatus, { exact: true }),
    device: effect_1.Schema.optionalWith(Device.Class.Common.Id, { exact: true }),
    orderBy: effect_1.Schema.optionalWith(exports.ExportOrderBy, { exact: true }),
    direction: effect_1.Schema.optionalWith(Common.SortDirection, { exact: true }),
})
    .pipe(effect_1.Schema.filter(filters => {
    const messages = [
        filters.orderBy !== undefined &&
            filters.direction === undefined &&
            'direction is required when orderBy is present.',
        filters.direction !== undefined &&
            filters.orderBy === undefined &&
            'orderBy is required when direction is present.',
        filters.start >= filters.end && 'start timestamp must occur before end.',
    ].filter((message) => typeof message === 'string');
    return messages.length === 0 || messages;
}, { jsonSchema: {} }))
    .annotations({
    identifier: `${exports.NAMESPACE}.ExportFilters`,
    title: 'AlarmsExportQueryParams',
    description: 'Alarm filters captured for the export. `orderBy` and `direction` must be given together; `start` must precede `end`.',
});
/** `CreateAlarmsExportJobBody` */
exports.CreateExportJobBody = effect_1.Schema.Struct({
    filterSnapshot: exports.ExportFilters,
}).annotations({
    identifier: `${exports.NAMESPACE}.CreateExportJobBody`,
    title: 'CreateAlarmsExportJobBody',
});
//# sourceMappingURL=schema.js.map